var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "layout" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "card" }, [
      _c("div", { staticClass: "card__content" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-xs-12 col-md-12" }, [
            _c("div", { staticClass: "form-inline" }, [
              _c("label", [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.tipoFecha,
                      expression: "form.tipoFecha"
                    }
                  ],
                  attrs: { type: "radio", value: "T" },
                  domProps: { checked: _vm._q(_vm.form.tipoFecha, "T") },
                  on: {
                    change: function($event) {
                      return _vm.$set(_vm.form, "tipoFecha", "T")
                    }
                  }
                }),
                _vm._v(" "),
                _c("span", [_vm._v("A la fecha")])
              ]),
              _vm._v(" "),
              _c("label", [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.tipoFecha,
                      expression: "form.tipoFecha"
                    }
                  ],
                  attrs: { type: "radio", value: "P" },
                  domProps: { checked: _vm._q(_vm.form.tipoFecha, "P") },
                  on: {
                    change: function($event) {
                      return _vm.$set(_vm.form, "tipoFecha", "P")
                    }
                  }
                }),
                _vm._v(" "),
                _c("span", [_vm._v("Personalizado")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.form.tipoFecha == "P",
                      expression: "form.tipoFecha == 'P'"
                    }
                  ],
                  staticClass: "form-field"
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "datepicker-field datepicker-field--stretch"
                    },
                    [
                      _c("VueCtkDateTimePicker", {
                        attrs: {
                          id: "desde",
                          locale: "es",
                          "only-date": "",
                          "no-label": "",
                          "button-now-translation": "Ahora",
                          format: "YYYY-MM-DD",
                          formatted: "YYYY-MM-DD",
                          label: "Seleccione fecha..."
                        },
                        model: {
                          value: _vm.form.fechaDesde,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "fechaDesde", $$v)
                          },
                          expression: "form.fechaDesde"
                        }
                      }),
                      _vm._v(" "),
                      _c("label", [_vm._v("Desde:")])
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.form.tipoFecha == "P",
                      expression: "form.tipoFecha == 'P'"
                    }
                  ],
                  staticClass: "form-field"
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "datepicker-field datepicker-field--stretch"
                    },
                    [
                      _c("VueCtkDateTimePicker", {
                        attrs: {
                          id: "desde",
                          locale: "es",
                          "only-date": "",
                          "no-label": "",
                          "button-now-translation": "Ahora",
                          format: "YYYY-MM-DD",
                          formatted: "YYYY-MM-DD",
                          label: "Seleccione fecha..."
                        },
                        model: {
                          value: _vm.form.fechaHasta,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "fechaHasta", $$v)
                          },
                          expression: "form.fechaHasta"
                        }
                      }),
                      _vm._v(" "),
                      _c("label", [_vm._v("Hasta:")])
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn-info btn--bigger ml-auto",
                  attrs: { type: "button" },
                  on: { click: _vm.consultar }
                },
                [
                  _c("i", { staticClass: "fa fa-search" }),
                  _c("span", [_vm._v("Consultar")])
                ]
              )
            ])
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row mt-3" }, [
      _c(
        "div",
        { staticClass: "col-xs-12" },
        [
          _c("k-table", {
            ref: "listaHistoricos",
            attrs: {
              buscarButton: false,
              mostrarTotales: false,
              editButton: false,
              deleteButton: false,
              filterStatus: false,
              createButton: false,
              path: _vm.path,
              columns: _vm.columnas,
              params: _vm.form,
              buttons: [
                {
                  event: "descargar",
                  icon: "fa-download",
                  class: "btn-success btn--text"
                }
              ]
            },
            on: { descargar: _vm.descargar }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__header" }, [
      _c("div", { staticClass: "layout__title" }, [
        _c("h3", [_vm._v("Historial")])
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-27e72584", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27e72584","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/general/ReportesHistoricosExcel.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-27e72584","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/general/ReportesHistoricosExcel.vue
// module chunks = 0